export type AdminGeoEvent = {
  event_type?: string | null;
  country?: string | null;
  reason?: string | null;
  metadata?: Record<string, unknown> | null;
};

export type AdminGeoConfidence = {
  level: 'HIGH' | 'MEDIUM' | 'LOW';
  knownRatio: number;
  total: number;
  reason?: 'insufficient_data' | 'missing_headers';
};

export const computeAdminGeoConfidence = (events: AdminGeoEvent[]): AdminGeoConfidence => {
  let known = 0;
  let unknown = 0;
  const getMetaString = (metadata: Record<string, unknown> | null | undefined, key: string) => {
    if (!metadata || typeof metadata !== 'object') return '';
    const value = metadata[key];
    return typeof value === 'string' ? value : '';
  };
  events.forEach((event) => {
    if (event.event_type !== 'admin_geo_observed') return;
    const country = event.country || getMetaString(event.metadata, 'country');
    const reason = event.reason || getMetaString(event.metadata, 'reason');
    if (country && reason !== 'geo_unknown_fail_open') {
      known += 1;
    } else {
      unknown += 1;
    }
  });

  const total = known + unknown;
  if (total < 20) {
    return { level: 'LOW', knownRatio: total === 0 ? 0 : known / total, total, reason: 'insufficient_data' };
  }

  const ratio = total === 0 ? 0 : known / total;
  if (ratio >= 0.9) {
    return { level: 'HIGH', knownRatio: ratio, total };
  }
  if (ratio >= 0.5) {
    return { level: 'MEDIUM', knownRatio: ratio, total };
  }
  return { level: 'LOW', knownRatio: ratio, total, reason: 'missing_headers' };
};
